export default {
  language: {
    pt: 'PT',
    en: 'EN',
  },
  header: {
    home: 'Início',
    howItWorks: 'Como Funciona',
    experiences: 'Experiências',
    contact: 'Contato',
    dashboard: 'Meu Dashboard',
    account: 'Conta',
    login: 'Entrar',
    generateFull: 'Criar Roteiro de Viagem',
    generateShort: 'Roteiro',
  },
  hero: {
    eyebrow: 'Travel Intelligence Platform',
    titleLine1: 'Planejamento de',
    titleLine2: 'Viagens com',
    titleLine3: 'Inteligência',
    sub1: 'IA estratégica para criar.',
    sub2: 'Especialistas para refinar.',
    sub3: 'Você para viver.',
    create: 'Criar Meu Roteiro',
    dashboard: 'Meu Dashboard',
    login: 'Entrar na minha conta',
    howItWorks: 'Ver Como Funciona',
    stats: {
      planning: 'Planejamento Inteligente',
      specialized: 'Especializada',
      support: 'Personalizado',
    },
  },
  loading: {
    title: 'Criando seu roteiro...',
    subtitle: 'Isso pode levar alguns segundos',
    tip: 'Estamos personalizando cada detalhe baseado no seu perfil',
    messages: [
      'Analisando seu perfil de viajante...',
      'Selecionando destinos ideais...',
      'Otimizando roteiro geográfico...',
      'Personalizando experiências...',
      'Calculando estimativa de investimento...',
      'Ajustando ritmo da viagem...',
      'Incluindo recomendações locais...',
      'Finalizando seu roteiro premium...',
    ],
  },
  wizard: {
    nav: {
      back: 'Voltar',
      next: 'Próximo',
      generate: 'Gerar Roteiro',
      stepCounter: '{{current}} de {{total}}',
      progressComplete: 'completo',
    },
    steps: {
      1: { title: 'Seu Perfil', description: 'Conte-nos um pouco sobre você' },
      2: { title: 'Estilo de Viagem', description: 'Como você gosta de viajar?' },
      3: { title: 'Regiões do Mundo', description: 'Quais regiões te interessam?' },
      4: { title: 'Ritmo da Viagem', description: 'Qual o ritmo ideal para você?' },
      5: { title: 'Preferência de Horário', description: 'Quando você prefere fazer atividades?' },
      6: { title: 'Viagens Anteriores', description: 'Onde você já esteve?' },
      7: { title: 'Experiências Obrigatórias', description: 'O que não pode faltar na sua viagem?' },
      8: { title: 'Experiências a Evitar', description: 'O que você prefere evitar?' },
      9: { title: 'Necessidades Especiais', description: 'Algo que devemos saber?' },
      10: { title: 'Seus Dados', description: 'Última etapa — enviaremos seu roteiro aqui' },
    },
    step10: {
      modeTitle: 'Como você quer definir o destino desta viagem?',
      modeDescription:
        'Podemos seguir com o destino que você já tem em mente ou sugerir opções compatíveis com o seu perfil antes de gerar o roteiro.',
      manualTitle: 'Já sei meu destino',
      manualDescription: 'Continue com o fluxo atual e gere o roteiro para o destino que você escolher.',
      suggestedTitle: 'Quero sugestões personalizadas',
      suggestedDescription: 'Montamos sugestões compatíveis com seu estilo, regiões de interesse e faixa de orçamento.',
      departureCity: 'Cidade de Partida',
      destination: 'Destino',
      destinationSuggested: 'Destino sugerido',
      destinationSuggestedDescription:
        'Escolha uma das sugestões abaixo. Quando você selecionar, seguimos com o fluxo normal da criação do roteiro.',
      suggestionsTitleOne: '1 destino compatível com seu perfil',
      suggestionsTitleOther: '{{count}} destinos compatíveis com seu perfil',
      suggestionsDescription: 'Baseado em estilo, regiões escolhidas, orçamento e histórico informado.',
      selectedSuffix: 'selecionado',
      useDestination: 'Usar destino',
      selected: 'Selecionado',
      recommendedFor: 'Recomendado para {{styles}}',
      whyRecommended: 'Por que recomendamos este destino',
      compatibility: 'Leitura de compatibilidade',
      weightedSignals: 'Sinais que pesaram',
      continueDescription: 'Ao continuar, seguimos com a geração do roteiro e a criação do seu passport normalmente.',
      noSuggestionTitle: 'Ainda não temos uma sugestão pronta para essa combinação',
      noSuggestionDescription:
        'Para manter a recomendação coerente com a região escolhida, preferimos não misturar continentes aqui. Se você já tem um destino em mente, siga pelo fluxo manual e continuamos normalmente.',
      backToManual: 'Já sei meu destino',
    },
  },
  result: {
    headerBrand: 'Aero Destiny Travel',
    contactConsultant: 'Falar com Consultor',
    errorTitle: 'Ops! Algo deu errado',
    retry: 'Tentar Novamente',
    support: 'Falar com Suporte',
    successBadge: 'Roteiro gerado com sucesso',
    passportOpening: 'Abrindo seu Aero Passport em instantes...',
    heroTitlePrefix: 'Seu Roteiro para',
    heroSubtitle: '{{days}} dias de experiências exclusivas para {{people}} viajante{{suffix}} — estilo {{style}}',
    specialistNow: 'Falar com Especialista Agora',
    profileTitle: 'Perfil: {{name}}',
    profileSubtitle: 'Roteiro personalizado para o seu estilo',
    cards: {
      destination: 'Destino',
      style: 'Estilo',
      travelers: 'Viajantes',
      duration: 'Duração',
      investment: 'Investimento',
    },
    profileTipsTitle: 'Dicas Exclusivas para {{style}}',
    profileTipsSubtitle: 'Sugestões personalizadas para o seu perfil de viajante',
    hiddenGemBadge: 'Dica Exclusiva — Joia Escondida',
    hiddenGemTitle: 'Experiência Pouco Óbvia em {{destination}}',
    destinationInfoTitle: 'Informações sobre {{destination}}',
    destinationInfo: {
      climate: 'Clima',
      currency: 'Moeda',
      language: 'Idioma',
      bestMonths: 'Melhor Época',
      timeZone: 'Fuso Horário',
      visa: 'Visto',
      vaccines: 'Vacinas',
    },
    hotelTitle: 'Hospedagem Recomendada',
    itineraryBadge: 'Roteiro Dia a Dia',
  },
  auth: {
    login: {
      title: 'Aero Passport',
      subtitle: 'Suas viagens e memórias em uma só conta. Informe seu e-mail para entrar ou criar sua conta com um código de uso único. Sem senha.',
      flightFollowTitle: 'Confirme este acompanhamento de voo',
      flightFollowSubtitle:
        'Entre primeiro para ligar este convite compartilhado de voos à sua conta e voltar para a viagem certa.',
      flightFollowCardTitle: 'Este é um convite de acompanhamento, não um login genérico',
      flightFollowCardBody:
        'Depois de entrar, você volta para a viagem compartilhada e confirma que quer acompanhar esses voos.',
      emailLabel: 'Seu e-mail',
      emailPlaceholder: 'voce@email.com',
      submit: 'Enviar código por e-mail',
      cooldownButton: 'Aguarde {{seconds}}s',
      sending: 'Enviando...',
      success: 'Confira o código mais recente no seu e-mail e digite-o abaixo para continuar.',
      successFollow:
        'Confira o código mais recente no seu e-mail. Digite-o abaixo para confirmar este acompanhamento de voo.',
      otpLabel: 'Código de uso único',
      otpPlaceholder: '00000000',
      otpSubmit: 'Confirmar código',
      otpVerifying: 'Confirmando...',
      otpHelper: 'Use o código mais recente do e-mail. Você pode manter esta tela aberta enquanto confere sua caixa de entrada.',
      helper: 'É sua primeira vez? Ao verificar seu e-mail, sua conta é criada automaticamente. Sem cadastro separado ou senha.',
      flightFollowHelper:
        'O convite de acompanhamento continua ligado a esta rota. Entre uma vez, volte e então confirme o convite.',
      cooldownHint:
        'Um acesso já foi solicitado recentemente. Aguarde {{seconds}} segundos antes de tentar de novo. Se você já recebeu o e-mail mais recente, use o código dele.',
      errors: {
        supabaseMissing: 'Supabase não configurado.',
        missingEmail: 'Digite seu e-mail.',
        invalidEmail: 'Digite um e-mail válido.',
        rateLimit:
          'Muitos pedidos de acesso foram enviados. Aguarde cerca de {{seconds}} segundos e tente de novo. Se você já recebeu um e-mail, use o código mais recente.',
        cooldownActive:
          'Um acesso já foi solicitado há pouco. Aguarde {{seconds}} segundos antes de enviar outro.',
        missingOtp: 'Digite o código recebido no e-mail.',
        invalidOtp: 'O código é inválido ou expirou. Solicite um novo e-mail de acesso e tente novamente.',
        generic: 'Erro ao enviar o e-mail de acesso.',
      },
    },
    callback: {
      title: 'Aero Passport App',
      flightFollowTitle: 'Confirmando seu acesso ao acompanhamento de voos',
      default: 'Confirmando seu acesso...',
      flightFollow: 'Confirmando seu acesso e trazendo você de volta para o convite compartilhado de voos...',
    },
  },
  dashboard: {
    hero: {
      eyebrow: 'Aero Passport App',
      welcome: 'Bem-vindo de volta, {{name}}',
      subtitle:
        'Aqui ficam guardadas as suas viagens, roteiros e experiências em um só lugar. Cada passport registra um novo capítulo da sua jornada.',
      connectedAs: 'Conectado como',
      archiveCountOne: '{{count}} passport no seu arquivo',
      archiveCountOther: '{{count}} passports no seu arquivo',
      helper: 'Abra uma viagem, retome um roteiro ou comece uma nova experiência quando quiser.',
    },
    actions: {
      createTrip: 'Criar nova viagem',
      logout: 'Sair',
      openPassport: 'Abrir passport',
    },
    stats: {
      totalPassports: 'Total de Passports',
      activeTrips: 'Viagens ativas',
      completedTrips: 'Concluídas',
      templates: 'Bases reutilizáveis',
      shared: 'Guias compartilhados',
    },
    loading: 'Carregando viagens...',
    empty: {
      title: 'Seu histórico começa aqui',
      description:
        'Crie sua primeira viagem e transforme cada roteiro em um Aero Passport que você pode consultar, revisitar e compartilhar.',
    },
    disclosure: {
      open: 'Abrir',
      hide: 'Ocultar',
    },
    visibility: {
      public: 'Público',
      shared: 'Shared',
    },
    archive: {
      travelersOne: '{{count}} viajante',
      travelersOther: '{{count}} viajantes',
      createdOn: 'Criado em',
      activating: 'Ativando...',
      activateTemplate: 'Ativar base',
      activateShared: 'Ativar guia',
      creating: 'Criando...',
      useBase: 'Usar base',
      copyLink: 'Copiar link',
      openShared: 'Abrir guia',
    },
    mobile: {
      intelligence: {
        title: 'Próximo melhor passo',
        badge: 'Sugestões para agora',
        summary:
          'Com base nas suas viagens, o dashboard destaca o que mais vale retomar, compartilhar ou fechar agora.',
      },
      collection: {
        title: 'Guias e bases',
        badge: 'Biblioteca viva',
        summary:
          '{{shared}} guias e {{templates}} bases já podem circular ou ser reutilizados com mais clareza.',
      },
    },
    status: {
      created: 'Em análise',
      iddasCreated: 'Pronto para proposta',
      iddasFailed: 'Aguardando especialista',
      planning: 'Planejando',
      quotationRequested: 'Cotação solicitada',
      confirmed: 'Confirmado',
      traveling: 'Em viagem',
      completed: 'Concluído',
    },
    continueTrip: {
      traveling: {
        eyebrow: 'Sua viagem em andamento',
        title: 'Tudo pronto para usar durante a jornada',
        subtitle:
          'Acesse rapidamente o seu passport e consulte os detalhes da viagem sempre que precisar.',
      },
      confirmed: {
        eyebrow: 'Prepare sua próxima viagem',
        title: 'Seu passport já está pronto para acompanhar os próximos passos',
        subtitle:
          'Revise as informações da viagem e mantenha tudo à mão antes da partida.',
      },
      planning: {
        eyebrow: 'Continue planejando sua viagem',
        title: 'Seu roteiro já começou a ganhar forma',
        subtitle:
          'Retome o planejamento, revise os detalhes e continue construindo a experiência.',
      },
      quotationRequested: {
        eyebrow: 'Sua proposta está avançando',
        title: 'Seu passport acompanha a evolução da viagem',
        subtitle: 'Acompanhe o progresso e volte quando quiser para revisar o roteiro.',
      },
      iddasCreated: {
        eyebrow: 'Sua proposta está avançando',
        title: 'Seu passport já faz parte da próxima etapa',
        subtitle: 'Agora é um bom momento para revisar os detalhes e acompanhar a viagem.',
      },
      created: {
        eyebrow: 'Seu roteiro foi criado',
        title: 'Sua próxima viagem já tem um ponto de partida',
        subtitle: 'Abra o passport para revisar o destino, a proposta e os próximos passos.',
      },
      iddasFailed: {
        eyebrow: 'Finalize com um especialista',
        title: 'Seu roteiro está pronto para ser refinado',
        subtitle:
          'Revise o passport e avance com apoio humano para transformar o plano em viagem real.',
      },
      completed: {
        eyebrow: 'Reviva sua última viagem',
        title: 'Seu passport continua guardando essa jornada',
        subtitle:
          'Volte quando quiser para revisar os detalhes e manter seu histórico vivo.',
      },
      default: {
        eyebrow: 'Continue sua viagem',
        title: 'Seu passport está pronto para você',
        subtitle: 'Abra a viagem e continue de onde parou.',
      },
    },
  },
  homeSections: {
    howItWorks: {
      badge: 'Processo Consultivo',
      titleBefore: 'Como o',
      titleHighlight: 'Gerador de Roteiros',
      titleAfter: 'Funciona',
      description:
        'Da sua ideia ao roteiro completo em 4 etapas simples. Tecnologia de ponta e consultoria humana trabalhando juntas para criar a viagem dos seus sonhos.',
      cta: 'Gerar Meu Roteiro Agora',
      steps: {
        1: {
          title: 'Informe Seu Destino',
          description:
            'Escolha para onde quer ir, datas, número de viajantes e o estilo da sua viagem. Simples e rápido.',
        },
        2: {
          title: 'Personalize Preferências',
          description:
            'Defina seu orçamento, nível de experiência e hotel preferido. Quanto mais detalhes, melhor o resultado.',
        },
        3: {
          title: 'IA Gera Seu Roteiro',
          description:
            'Nossa inteligência artificial cria um roteiro dia a dia com experiências exclusivas selecionadas para o seu perfil.',
        },
        4: {
          title: 'Consultor Refina Tudo',
          description:
            'Um Travel Strategist especializado entra em contato para ajustar detalhes, buscar tarifas e garantir a viagem perfeita.',
        },
      },
    },
    contact: {
      badge: 'Consultor Inteligente de Viagens',
      titleLine1: 'Não sabe para onde ir?',
      titleLine2: 'Nós planejamos para você.',
      description:
        'Nossa IA analisa seu perfil, orçamento e estilo de vida para criar uma sugestão de roteiro feita exclusivamente para você — não um template, uma experiência pensada do início ao fim.',
      highlights: {
        profile: 'IA analisa seu perfil',
        itinerary: 'Roteiro dia a dia real',
        speed: 'Resultado em segundos',
        security: 'Dados protegidos',
      },
      qrHint: 'Aponte a câmera',
      directTitle: 'Prefere falar direto?',
      directDescription:
        'Escaneie o QR Code ou clique no botão para conversar com nosso time de consultores premium pelo WhatsApp.',
      whatsappCta: 'Abrir WhatsApp',
    },
    premium: {
      badge: 'Ideias curadas',
      titleLine1: 'Ideias de viagem',
      titleLine2: 'curadas pela Aero Destiny',
      description:
        'Explore pontos de partida para viagens com propósito. Nossa equipe refina rotas, hotéis, logística e experiências de acordo com o seu perfil.',
      cta: 'Criar meu roteiro em revisão',
      customCardTitleLine1: 'Experiência',
      customCardTitleLine2: 'de Travel Design',
      customCardDescription:
        'Não encontrou exatamente o que procura? Comece pelo destino e nossa equipe refina rota, hotéis e fluxo da viagem.',
      customCardCta: 'Criar meu roteiro em revisão',
      pricePrefix: 'Definido após revisão',
      processTitle: 'Como uma ideia vira uma viagem real',
      process: {
        1: {
          title: '1. Direção inicial',
          description:
            'Você escolhe uma ideia ou cria um pedido do zero para orientar o desenho da viagem.',
        },
        2: {
          title: '2. Revisão da consultoria',
          description:
            'A Aero Destiny ajusta rota, hotéis, logística e ritmo antes de transformar a ideia em proposta.',
        },
        3: {
          title: '3. Roteiro executável',
          description:
            'O resultado final prioriza clareza, suporte humano e uma viagem possível de executar.',
        },
      },
      cards: {
        safari: {
          category: 'NATUREZA E CULTURA',
          title: 'Safari no Quênia com foco em conservação',
          description:
            'Vida selvagem, direção de lodges e guias locais com ritmo pensado para reservas e conservação.',
          investment: 'Investimento definido após revisão',
          amenityLabels: ['Vida selvagem', 'Lodge direction', 'Guia local'],
        },
        cruise: {
          category: 'GASTRONOMIA E ROTA',
          title: 'Paris, Champagne e Vale do Loire',
          description:
            'Cidade, gastronomia, região de vinhos e uma rota refinada sem excesso de deslocamentos.',
          investment: 'Investimento definido após revisão',
          amenityLabels: ['Paris', 'Champagne', 'Vale do Loire'],
        },
        bali: {
          category: 'REFÚGIO ROMÂNTICO',
          title: 'Refúgio nas Maldivas',
          description:
            'Ritmo de resort, reef, traslados e dias de descanso desenhados para evitar uma viagem pesada.',
          investment: 'Investimento definido após revisão',
          amenityLabels: ['Reef', 'Traslados', 'Ritmo de resort'],
        },
        japan: {
          category: 'ROTA CURADA',
          title: 'Rota clássica do Japão',
          description:
            'Tóquio, Kyoto e Osaka com cultura, hotéis bem posicionados e logística ferroviária bem desenhada.',
          investment: 'Investimento definido após revisão',
          amenityLabels: ['Tóquio', 'Kyoto', 'Logística de trem'],
        },
        patagonia: {
          category: 'ROTA DE AVENTURA',
          title: 'Aventura nos Lençóis Maranhenses',
          description:
            'Lagoas, travessias, bases certas e logística local para uma viagem de natureza com bom ritmo.',
          investment: 'Investimento definido após revisão',
          amenityLabels: ['Lagoas', 'Travessias', 'Logística local'],
        },
      },
    },
    footer: {
      brandDescription:
        'Consultoria estratégica de viagens premium. Transformamos sonhos em experiências exclusivas e inesquecíveis para viajantes exigentes.',
      paymentTitle: 'Formas de Pagamento',
      navigationTitle: 'Navegação',
      contactTitle: 'Contato',
      socialTitle: 'Redes Sociais',
      location: 'Goiânia, GO - Brasil',
      rights: '© 2026 Aero Destiny Travel. Todos os direitos reservados.',
    },
    missionVision: {
      badge: 'Quem Somos',
      titleBefore: 'Nossa',
      titleHighlight: 'Essência',
      description:
        'Cada viagem que planejamos carrega nossos valores mais profundos — porque acreditamos que viajar é uma das formas mais poderosas de transformar vidas.',
      imageAlt: 'Aero Destiny Travel - Nossa Visão',
      imageTitleBefore: 'Transformando Sonhos em',
      imageTitleHighlight: 'Destinos Reais',
      cards: {
        mission: {
          label: 'MISSÃO',
          text: 'Compartilhar nosso conhecimento e experiência em viagens, tanto no Brasil quanto no exterior, para criar roteiros únicos e enriquecedores.',
        },
        vision: {
          label: 'VISÃO',
          text: 'Ser reconhecida como uma agência de viagens inovadora e inspiradora, referência em experiências transformadoras.',
        },
        values: {
          label: 'VALORES',
          text: 'Curiosidade e aventura; expertise e qualidade; personalização e empatia; inovação e inspiração; respeito e sustentabilidade; confiança e honestidade.',
        },
      },
    },
  },
};
